import React from "react";
import { Reveal } from "@/components/Reveal";
import { Eyebrow } from "@/components/SectionDivider";

const FEATURES = [
  {
    title: "Client-Named Accounts",
    body: "All accounts opened directly in your name. You own every asset, end-to-end.",
  },
  {
    title: "Full Transparency",
    body: "Every transaction visible in real-time via your own online dashboards.",
  },
  {
    title: "LRS Compliant",
    body: "All remittances under RBI's LRS — fully legal, fully documented.",
  },
  {
    title: "Focused Strategy",
    body: "15 to 25 global monopolies held with genuine conviction. No noise.",
  },
  {
    title: "Global Liquidity",
    body: "Access your capital from New York, Dubai, Singapore or London.",
  },
  {
    title: "Experienced Management",
    body: "Deep analytical rigour on every decision. Your capital is managed, never parked.",
  },
];

const WhyUs = () => {
  return (
    <section
      id="why-us"
      data-testid="why-us-section"
      className="relative bg-[#080808] py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal>
          <Eyebrow testId="why-eyebrow">Why The Global Vault</Eyebrow>
          <h2
            data-testid="why-heading"
            className="font-serif-display text-[#C9960C] text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05] max-w-3xl"
          >
            What Makes Us Different
          </h2>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-7">
          {FEATURES.map((f, idx) => (
            <Reveal key={f.title} delay={(idx % 3) * 0.08}>
              <article
                data-testid={`why-card-${idx + 1}`}
                className="group bg-[#1C1C1C] border border-[#C9960C]/40 border-t-2 border-t-[#C9960C] p-9 md:p-10 h-full transition-all duration-500 hover:-translate-y-1 hover:border-[#C9960C]"
              >
                <span className="font-serif-display text-[#C9960C]/70 text-xl block mb-4">
                  {`0${idx + 1}`}
                </span>
                <h3 className="font-serif-display text-[#F5D485] text-2xl mb-3 tracking-tight">
                  {f.title}
                </h3>
                <p className="text-[#F8F6F0]/75 leading-relaxed text-[15px]">{f.body}</p>
                <div className="mt-6 h-px w-10 bg-[#C9960C]/40 group-hover:w-24 transition-all duration-500" />
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
